import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

import { IOptionsResponse } from '../../../common/common.types'
import { setMedicalConsultFacilityOptions } from '../store/options.actions'
import { OptionsService } from '../services/options.service'

export function* getMedicalConsultFacilityOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const response: IOptionsResponse = yield call([optionsService, optionsService.getMedicalConsultFacilityOptions])
    const { entity } = response
    if (entity) yield put(setMedicalConsultFacilityOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getMedicalConsultFacility() error: ${e}`))
  }
}

export function* getMedicalConsultFacilityOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getMedicalConsultFacilityOptions)
}
